<template>
  <div class="test-qurum">
 
<OperationCard :oneConfirmButton="false"    v-for="(detOffice, index) in officeDetails"
     :indice="index" :key="'detOffice' + index"   :detOffice="detOffice" :privilege="privilege"
     :problem="problem" :noExecutorWarning="noExecutorWarning" @submit="handleSubmit"  :structures='structures'/>
    <!--media dialog-->


  </div>
</template>

<script>
import MyFileUpload from "@/components/partials/MyFileUpload/index";
import mixin from "@/mixins/index";
import moment from "moment";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";

import OperationCard from '@/components/partials/OperationCard'



export default {
  name: "OperationDetail",
  props: {
    problem: Object,
    privilege: Object,
    structures: Array,
    noExecutorWarning: Boolean,
  },
  mixins: [mixin],
  components: {
    "my-file-upload": MyFileUpload,
    "conditional-media": ConditionalMedia,
    OperationCard
  },
  data() {
    return {
      // officeDetails: this.problem.officeDetails,
      selectedOfficeId: null,
      offices: [],
      filteredOffices: [],
      selectedOfficeIds: [],
      myOffices: [],
      
      officeError: null,

      files: [],
      detOfficeOpened: null,
      subOffices: [],
   
      
     
      selectedFiles: [],
     
      officeDetails: []
    };
  },
  computed: {
    // officeDetails: function () {
    //   return this.problem ? this.problem.officeDetails : [];
    // },
  },
  watch: {
    problem: {
      immediate: true,
      handler: function(val) {
        if (val) this.officeDetails = val.officeDetails;
        else this.officeDetails = [];
      }
    },
    officeDetails: val => console.log(val)
  },
  methods: {





    moment,


    removeSent(parOfficeId) {
      this.officeDetails = this.officeDetails.filter((item) =>
        item.parentOffice ? item.parentOffice.id !== parOfficeId : true
      );
    },









    remove(officeDetail) {
      this.$emit("removed", officeDetail);
    },
handleSubmit({ button, detailOffice, result , commentarStructures}) {
      this.$emit("submit",{button, detailOffice, commentarStructures, result});
    },
   
  },
  created() {
   
    // this.officeDetails = this.problem.officeDetails;
    this.officeDetails.forEach((item) => {
    

    });
    let initialIds = this.structures
      ? this.structures.map((item) => item.id)
      : [];
    if (
      this.privilege.selectParentOffice === "REQUIRED" ||
      this.privilege.selectParentOffice === "OPTIONAL"
    ) {
     

      /* if(this.user.structure.askForRedirection){
          this.getExecutorStructures(this.user.structure.id).then(response => {
            if (!response.data.error) {
              this.myOffices = response.data.data.entities;
            }
          });
        } */
    }

 
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
